import React from 'react';
import { Button, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { Field, Fields, reduxForm } from 'redux-form';
import math from 'mathjs';
import numeral from 'numeral';

// components
import renderField from '../../partials/form/render-field';

const calculateMonthlyPayment = ({ amount, interestRate, term }) => {
  /*
    M = monthly payment
    P = principal, the initial amount of the loan 
    I = the annual interest rate (from 1 to 100 percent) 
    N = number of months over which loan is amortized
    J = monthly interest in decimal form = I / (12 x 100) 
  
                           J
         M = P x ----------------------
                   1 - ( 1 + J ) ^ -N
  */
  const termMonths = term * 12;
  const monthlyIntrest = interestRate / (12 * 100);
  const monthlyPayment = math.eval(
    `${amount} * (  ${monthlyIntrest} / (1 - (1 + ${monthlyIntrest})^(-${termMonths})) )`
  );

  return monthlyPayment;
};

const calculateTotalInterest = ({ amount, interestRate, term, monthlyPayment }) => {
  var ip,
    totalInterest = 0.0,
    month = 0,
    principal = amount;

  const termMonths = term * 12;
  const interestByMonth = interestRate / 12;

  for (; month < termMonths; month++) {
    ip = 0.01 * Math.round(principal * interestByMonth);
    principal = principal + ip - monthlyPayment;
    totalInterest += ip;
  }

  return totalInterest;
};

const calculateResults = values => {
  const monthlyPayment = calculateMonthlyPayment(values);
  const totalInterest = calculateTotalInterest({
    ...values,
    monthlyPayment
  });
  const totalCost = totalInterest + values.amount;
  return {
    monthlyPayment,
    totalInterest,
    totalCost
  };
};

const renderResults = ({ amount, term, interestRate, startDate }) => {
  const results = calculateResults({
    amount: parseFloat(amount.input.value, 10),
    term: parseInt(term.input.value, 10),
    interestRate: parseFloat(interestRate.input.value, 10)
    // startDate: startDate.input.value
  });

  return (
    <div>
      <FormGroup row>
        <Label for="monthlyPayment" md={5}>
          Monthly Payment:
        </Label>
        <Col md={7}>
          <Input name="monthlyPayment" type="text" plaintext tabIndex={4}>
            {numeral(results.monthlyPayment).format('$0,000.00')}
          </Input>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="totalInterest" md={5}>
          Total Interest Paid:
        </Label>
        <Col md={7}>
          <Input name="totalInterest" type="text" plaintext tabIndex={5}>
            {numeral(results.totalInterest).format('$0,000.00')}
          </Input>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="totalCost" md={5}>
          Total Cost of Loan:
        </Label>
        <Col md={7}>
          <Input name="totalCost" type="text" plaintext placeholder="$0.00" tabIndex={6}>
            {numeral(results.totalCost).format('$0,000.00')}
          </Input>
        </Col>
      </FormGroup>
    </div>
  );
};

let MortgageCalculatorForm = ({ handleSubmit, reset, initialValues }) => {
  return (
    <Form>
      <Row>
        <Col md={6}>
          <h6>Inputs</h6>
          <FormGroup row>
            <Label for="amount" md={5}>
              Loan Amount:
            </Label>
            <Col md={7}>
              <Field
                name="amount"
                type="text"
                placeholder="$0.00"
                component={renderField}
                tabIndex={1}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="term" md={5}>
              Term (in Years):
            </Label>
            <Col md={7}>
              <Field
                name="term"
                type="text"
                placeholder="0"
                component={renderField}
                tabIndex={2}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="interestRate" md={5}>
              Interest Rate:
            </Label>
            <Col md={7}>
              <Field
                name="interestRate"
                type="text"
                placeholder="0"
                component={renderField}
                tabIndex={3}
              />
            </Col>
          </FormGroup>
          {/*
          <FormGroup row>
            <Label for="startDate" md={5}>
              Start Date:
            </Label>
            <Col md={7}>
              <Field name="startDate" type="date" component={renderField} tabIndex={4} />
            </Col>
          </FormGroup>
          */}
        </Col>
        <Col
          md={{
            offset: 1,
            size: 5
          }}
        >
          <h6>Results</h6>
          <Fields
            names={['amount', 'term', 'interestRate', 'startDate']}
            component={renderResults}
          />
          <FormGroup row>
            <Col
              md={{
                size: 7,
                offset: 5
              }}
            >
              <Button color="primary" type="reset" onClick={reset}>
                Reset
              </Button>
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default reduxForm({
  form: 'mortgage-calculator-form'
})(MortgageCalculatorForm);



// WEBPACK FOOTER //
// ./src/forms/mortgage-calculator-form/mortgage-calculator-form.js